import {createEventActionDetails} from './utils';
import {CONFIG, HOIST_COMPOSED_PATH} from '../symbols';
import {SEISMIC_HOIST_TAG_NAME} from '../constants';
import {getHostVariables} from '../utils';

const allowedPropertyUpdates = ['payload', 'error', 'meta'];

function getPath(meta, host) {
	if (meta.event.path) return meta.event.path;

	const path = [];
	let el = host;
	let parentNode = el.parentNode || el.host;
	while (parentNode) {
		path.push(el);
		el = parentNode;
		parentNode = el.parentNode || el.host;
	}

	return [...path, document, window];
}

function getComposedPath(meta, host) {
	const hoistComposedPath = meta[HOIST_COMPOSED_PATH];

	if (!hoistComposedPath) return meta.event.composedPath();

	const composedPath = [];
	for (let i = 0; i < hoistComposedPath.length; i++) {
		const el = hoistComposedPath[i];
		if (el.tagName === SEISMIC_HOIST_TAG_NAME) break;

		composedPath.push(el);
	}

	return [...composedPath, ...getPath(meta, host)];
}

export function addActionHandler(
	targetEl,
	targetSelector,
	host,
	type,
	capture,
	eventHandler,
	handler
) {
	const hostVariables = getHostVariables(host);
	const listener = event => {
		const config = hostVariables[CONFIG];
		const detail = createEventActionDetails(type, host, event, capture, eventHandler);
		handler(
			targetEl,
			targetSelector,
			host,
			type,
			new Proxy(
				{
					...detail,
					stopPropagation() {
						return event.stopPropagation();
					}
				},
				{
					get(action, key) {
						const {payload, meta} = action;
						if (key === 'defaultPrevented') {
							return payload && payload.event
								? payload.event.defaultPrevented
								: event.defaultPrevented;
						}

						if (key === 'preventDefault') {
							return () =>
								payload && payload.event ? payload.event.preventDefault() : event.preventDefault();
						}

						if (key === 'composedPath') return () => getComposedPath(meta, host);

						return action[key];
					},
					set(action, key, value) {
						if (allowedPropertyUpdates.includes(key)) {
							action[key] = value; // eslint-disable-line no-param-reassign
							return true;
						}

						return false;
					}
				}
			)
		);

		if (config && config.shouldStopPropagation[type]) event.stopPropagation();
	};

	targetEl.addEventListener(type, listener, capture);
	return function removeActionHandler() {
		targetEl.removeEventListener(type, listener, capture);
	};
}
